export default __webpack_public_path__ + "static/media/MetallicPaint.16793e55.png";